import React from 'react';
import { fieldClass } from './TextField';
type TextAreaFieldProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  name: string;
  error?: string;
};
export function TextAreaField({
  label,
  name,
  error,
  required,
  className = '',
  rows = 5,
  ...rest
}: TextAreaFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-70" data-mp="2ipn78h088lny">
      <label htmlFor={id} className="font-slab text-xs font-bold uppercase tracking-[0.2em]" data-id="element-71" data-mp="2wicsgj7xlmk0">
        {label}
        {required && <span className="text-ink-muted" data-id="element-72" data-mp="2shj6hve1uhtr"> *</span>}
      </label>
      <textarea id={id} name={name} rows={rows} required={required} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} className={`${fieldClass} resize-y ${error ? 'border-red-400' : ''}`} {...rest} data-id="element-73" data-mp="2sj3zhgkptspi" />
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs text-red-300" data-id="element-74" data-mp="173ohmmezoco3">
          {error}
        </p>}
    </div>;
}